














import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ConfirmDialog extends Vue {
  @Prop({ required: false })
  public title!: string;

  @Prop({ required: true })
  public message!: string; 

  @Prop({ required: true })
  public value!: boolean;

  @Prop({ required: false })
  public cancelBtnText!: string;

  @Prop({ required: false })
  public okBtnText!: string;

  @Prop({ required: false })
  public width!: number;

  @Prop({ required: false })
  public data!: any;

  constructor() {
    super();    
  }

  protected ConfirmClick(value: boolean): void {
    this.$emit('input', !this.value);
    this.$emit('onConfirm', value, this.data);
  }

  protected get dialogWidth(): number {
    return this.width > 0 ? this.width : 300; // 300 = default
  }

  protected get buttonCancelText(): string {
    return this.cancelBtnText ? this.cancelBtnText : 'No'; // "No" = default
  }

  protected get buttonOkText(): string {
    return this.okBtnText ? this.okBtnText : 'Yes'; // "Yes" = default
  }
}
